/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ILinkProps, Link } from '@fluentui/react/lib/Link';
import React from 'react';
import { getScopedTheme } from 'src/core/themes/luisStylist';

const theme = getScopedTheme('NameCellLink');

/**
 * Renders a link that is primarily to be used for
 * clickable names in the data tables in the portal,
 */
export const NameCellLink = (props: React.PropsWithChildren<ILinkProps>) => {
    const { children, onClick, ...rest } = props;

    /**
     * Passes through the event, triggers the onClick
     * handler, and stops the event from propagating.
     *
     * @param e The event object that resulted.
     */
    const onClickWithEventStopping = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.stopPropagation();

        if (onClick) {
            onClick(e);
        }
    };

    return (
        <Link styles={{ root: { lineHeight: '20px', fontSize: theme.fontSize } }} role="link" onClick={onClickWithEventStopping} {...rest}>
            {children}
        </Link>
    );
};
